<template>
  <div class="toolbar">
    <div class="search">
      <div class="d-flex">
        <RexSearchSelect
          v-if="showCap"
          :current="getCurrentCapability"
          :data="getCapabilities()"
          width="18.75rem"
          @onChoose="(item) => selectCapabilityOption(item)"
          :searchPlaceholder="$t('searchCapability')"
          :heading="$t('selectCapability')"
          :objectValueIndex="1"
          class="capability-dropdown"
          id="search-select-capablity"
        />
        <RexSearchSelect
          :current="getCurrentAlarmService"
          :data="serviceTypeHandler"
          width="18.75rem"
          @onChoose="(item) => changeSeriesType(item)"
          :searchPlaceholder="$t('searchApplication')"
          :heading="$t('selectApplication')"
          :objectValueIndex="1"
          id="search-select-application"
          v-if="showApplicationSelector"
        />
        <div class="select-apps-container" v-if="showSelectV3">
          <div class="heading">{{ $t('selectApplication') }} :</div>
          <RexSelectV3
            :showSearch="true"
            @onPopupScroll="scrollServices"
            @onSearch="onSearchService"
            @onChange="onHandleService"
            :value="selectedService"
            @onDropdownVisibleChange="onOpenSelectField"
            id="search-select-application"
            :customStyle="{ width: '18.75rem' }"
          >
            <template #default>
              <RexSelectOption
                v-for="(obj, i) in servicesData"
                :key="`${obj.key}-${i}`"
                :value="obj.label"
                :permissions="obj.permissions"
              >
                <RexTooltipV3
                  :title="obj.label"
                  placement="right"
                  class="service-opt-tooltip"
                >
                  <div class="service-opt-tooltip-text">
                    {{ obj.label }}
                  </div>
                </RexTooltipV3>
              </RexSelectOption>
              <RexSelectOption
                :disabled="true"
                v-if="isLoading"
                key="loading"
                :value="searchService"
              >
                <div class="services-loading-box">
                  <RexSpinV3 v-if="isLoading" size="small" />
                </div>
              </RexSelectOption>
            </template>
          </RexSelectV3>
        </div>
        <MobileHeader v-if="showMobileHeader" />
        <IntegrationHeader v-if="showIntegrationHeader" />
        <ForecastToggle
          :showForecastToggle="showForecastToggle"
          :isForcastEnabled="isForcastEnabled"
          @change="onForecastChange"
          :disabled="!enabledAI"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import RexSearchSelect from '@/rex-components/RexSearchSelect.vue';
import MobileHeader from '@/components/Mobile/Header/MobileHeader.vue';
import SMHeader from '@/components/SM/Applications/SMHeader.vue';
import BuildConfig from '@/environment';
import {
  CAPABILITY_APM,
  CAPABILITY_BROWSER,
  CAPABILITY_MOBILE,
  CAPABILITY_VM,
  CAPABILITY_SM,
} from '@/utils/constants';
import Browser from '@/utils/templates/browser.template';
import APM from '@/utils/templates/apm.template';
import Mobile from '@/utils/templates/mobile.template';
import VM from '@/utils/templates/vm.template';
import SM from '@/utils/templates/sm.template';
import K8M from '@/utils/templates/k8m.template';
import Integrations from '@/utils/templates/integrations';
import settings from '@/utils/templates/settings.template';
import IntegrationHeader from '@/components/Cloud/Settings/header';
import { RexSelectOption } from '@/rex-components/rex.comp.config';
import graphQl from '@/services/graphQl';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import RexSpinV3 from '@/rex-components/RexSpinV3.vue';
import RexSelectV3 from '@/rex-components/RexSelectV3.vue';
import RexTooltipV3 from '@/rex-components/RexTooltipV3.vue';
import BM from '@/utils/templates/browser.template.js';
import {
  PAGE_SIZE_SCROLL,
  SELECT_FIELD_DEBOUNCE_DURATION_IN_MS,
  SELECT_FIELD_THROTTLE_DURATION_IN_MS,
} from '@/utils/constants';
import router from '@/router';
import { ALL_TYPE_APP } from '@/components/Mobile/mobile.constants';
import ForecastToggle from '@/components/IntegrationUtils/ForecastToggle.vue';
import { permissionTypes } from '@/router/constant';

export default {
  components: {
    RexSearchSelect,
    MobileHeader,
    SMHeader,
    IntegrationHeader,
    RexSelectV3,
    RexSpinV3,
    RexSelectOption,
    RexTooltipV3,
    ForecastToggle,
  },
  data() {
    return {
      text: '',
      showModal: false,
      selected: {},
      curservice: {},
      service: {
        sservice: {},
      },
      showForecast: [
        'service',
        'instancePerformance',
        'infraDetails',
        'overall',
        'endpointGraph',
        'crashesGraphs',
        'performanceGraphs',
        'pagesGraph',
        'application',
      ],
      enabledAI: false,
      alertsCapabilities: [
        {
          key: CAPABILITY_APM,
          label: APM.name,
        },
        {
          key: CAPABILITY_BROWSER,
          label: Browser.name,
        },
        {
          key: CAPABILITY_MOBILE,
          label: Mobile.name,
        },
        {
          key: CAPABILITY_VM,
          label: VM.name,
        },
        {
          key: CAPABILITY_SM,
          label: SM.name,
        },
      ],
      settingsCapabilities: [
        {
          key: CAPABILITY_APM,
          label: APM.name,
        },
        {
          key: CAPABILITY_BROWSER,
          label: Browser.name,
        },
      ],
      servicesData: [],
      isLoading: false,
      currentPage: 1,
      totalPages: 1,
      searchService: '',
      capabilitySelected: {},
    };
  },

  computed: {
    // a computed getter
    ...mapState('globalState', ['app']),
    ...mapState('globalState/app', ['isForcastEnabled']),
    ...mapState('globalState/app', ['currentSideNav']),
    ...mapGetters('globalState/user', ['getTeamId']),
    ...mapState('apmState/apmCommonState', ['services', 'currentService']),
    ...mapState('browserState/browserCommonState', [
      'currentBrowserService',
      'browserServices',
    ]),
    ...mapGetters('apmState/apmCommonState', ['getServices']),
    ...mapGetters('globalState/settings', ['getDurationTime']),
    ...mapGetters('browserState/browserCommonState', [
      'getAllBrowserServices',
      'getCurrentBrowserService',
    ]),
    ...mapGetters('mobileState/mobileCommonState', [
      'getAllMobileServices',
      'getCurrentMobileService',
    ]),
    ...mapGetters('vmState/vmCommonState', ['getAllVMServices']),
    ...mapGetters('syntheticState/commonState', ['getAllSyntheticServices']),
    ...mapGetters('alarmState', ['getCurrentAlarmService']),
    ...mapState('mobileState/mobileCommonState', ['currentMobileService']),
    capability() {
      if (this.$route.path.includes('alert')) {
        return true;
      } else {
        return false;
      }
    },
    getCurrentCapability() {
      let currentCapability;
      this.getCapabilities().forEach((element) => {
        if (element.key == this.app.currentCapability)
          currentCapability = element.label;
      });
      return currentCapability;
    },
    serviceTypeHandler() {
      let key = this.app.currentCapability;
      let serviceType;
      switch (key) {
        case CAPABILITY_BROWSER:
          serviceType = this.getAllBrowserServices;
          break;
        case CAPABILITY_APM:
          serviceType = this.getServices;
          break;
        case CAPABILITY_MOBILE:
          serviceType = this.getAllMobileServices;
          break;
        case CAPABILITY_VM:
          serviceType = this.getAllVMServices;
          break;
        case CAPABILITY_SM:
          serviceType = this.getAllSyntheticServices;
          break;
        default:
          break;
      }
      return serviceType;
    },
    showCap() {
      return (
        this.$route.fullPath.includes('serviceSettings') ||
        (this.app && this.app.currentSideNav.name === 'Alerts')
      );
    },
    showApplicationSelector() {
      return (
        this.app &&
        this.currentSideNav.name !== Mobile.name &&
        this.currentSideNav.name !== SM.name &&
        this.currentSideNav.name !== K8M.name &&
        this.currentSideNav.name !== APM.name &&
        this.currentSideNav.name !== settings.name &&
        this.currentSideNav.name !== BM.name
      );
    },
    showSelectV3() {
      return (
        this.app &&
        (this.app.currentSideNav.name === APM.name ||
          this.app.currentSideNav.name === BM.name ||
          this.app.currentSideNav.name === Mobile.name ||
          this.app.currentSideNav.name === settings.name)
      );
    },
    showMobileHeader() {
      return this.app && this.app.currentSideNav.name === Mobile.name;
    },
    showIntegrationHeader() {
      return this.app && this.app.currentSideNav.name === Integrations.name;
    },
    showForecastToggle() {
      return (
        this.app &&
        (this.app.currentSideNav.name === APM.name ||
          this.app.currentSideNav.name === Browser.name ||
          this.app.currentSideNav.name === Mobile.name) &&
        this.showForecast.includes(this.$route.name)
      );
    },
    isForcastEnabled() {
      return this.app.isForcastEnabled;
    },
    selectedService() {
      const currentCapability = this.app.currentCapability;
      switch (currentCapability) {
        case CAPABILITY_BROWSER:
          return this.currentBrowserService?.label ?? '';
        case CAPABILITY_APM:
          return this.currentService?.label ?? '';
        case CAPABILITY_MOBILE:
          return this.currentMobileService?.label ?? '';
        default:
          return '';
      }
    },
  },
  methods: {
    ...mapActions('apmState/apmCommonState', ['selectService']),
    ...mapActions('browserState/browserCommonState', ['selectBrowserService']),
    ...mapActions('mobileState/mobileCommonState', ['selectMobileService']),
    ...mapActions('vmState/vmCommonState', ['selectVMService']),
    ...mapActions('syntheticState/commonState', ['SELECT_SYNTHETIC_SERVICE']),
    ...mapMutations('globalState/app', ['setCurrentService']),
    ...mapMutations('mobileState/mobileCommonState', [
      'setCurrentMobileService',
    ]),
    ...mapMutations('apmState/trace', ['setCurrentTraceId']),
    ...mapMutations('globalState/app', [
      'setCurrentService',
      'setIsForcastEnabled',
    ]),
    ...mapMutations('globalState/settings', ['setIsCompareOptionsSelected']),
    ...mapActions('globalState/settings', ['checkAIenable']),
    ...mapActions('globalState/app', ['toggleForecast']),

    //TODO: Need to extend this for all the remaining capabilities
    onOpenSelectField(open) {
      if (open && this.searchService) {
        this.currentPage = 1;
        this.searchService = '';
        this.getAllServices();
      }
    },
    async checkAI() {
      const params = {
        request: {
          teamId: this.getTeamId,
        },
      };
      const res = await this.checkAIenable(params);
      this.enabledAI = res.enabledAI;
    },
    capabilityServiceReqKey() {
      switch (this.currentSideNav?.key) {
        case BM.key:
          return 'B';
        case APM.key:
          return 'A';
        case settings.key:
          return this.capabilitySelected?.key === APM.name ? 'A' : 'B';
        case Mobile.key:
          return 'M';
        default:
          return 'A';
      }
    },
    async getAllServices() {
      try {
        this.isLoading = true;
        const { data } = await graphQl
          .query('queryServicesWithTotalCount')
          .params({
            duration: this.getDurationTime,
            keyword: this.searchService || '',
            serviceReq: {
              capability: this.capabilityServiceReqKey(),
            },
            pagination: {
              pageNum: this.currentPage,
              pageSize: PAGE_SIZE_SCROLL,
              needTotal: true,
            },
            permissions: [permissionTypes.READ, permissionTypes.WRITE],
          });

        let applicationsData = data.data?.services?.services;
        this.totalPages =
          Math.ceil(data?.data?.services?.total / PAGE_SIZE_SCROLL) || 1;
        if (
          this.currentPage === 1 &&
          router.currentRoute.value &&
          router.currentRoute.value.name === 'mblDashboard' &&
          data?.data?.services?.total !== 0
        ) {
          applicationsData.unshift(ALL_TYPE_APP);
        }
        if (applicationsData && Array.isArray(applicationsData)) {
          if (!this.selectedService) {
            this.changeSeriesType(applicationsData?.[0]);
          }
          this.servicesData =
            this.currentPage === 1
              ? applicationsData
              : [...this.servicesData, ...applicationsData];
        }
        this.isLoading = false;
      } catch (error) {
        console.log('error', error);
        this.isLoading = false;
        this.servicesData = [];
      }
    },
    scrollServices: throttle(function (event) {
      const target = event.target;
      if (
        !this.isLoading &&
        target.scrollTop + target.offsetHeight >= target.scrollHeight - 10 &&
        this.currentPage < this.totalPages
      ) {
        this.currentPage += 1;
        this.getAllServices();
      }
    }, SELECT_FIELD_THROTTLE_DURATION_IN_MS),
    onSearchService: debounce(function (val) {
      this.currentPage = 1;
      this.searchService = val;
      this.getAllServices();
    }, SELECT_FIELD_DEBOUNCE_DURATION_IN_MS),
    onHandleService(value, option) {
      this.setCurrentTraceId('');
      const key = option.key?.split('-')?.[0];
      const serviceDetails = { ...option, key, label: option?.value };
      this.changeSeriesType(serviceDetails);
      if (this.searchService) {
        this.currentPage = 1;
        this.searchService = '';
        this.getAllServices();
      }
    },
    onForecastChange(data) {
      this.setIsForcastEnabled(data);
      this.toggleForecast(data);
      this.setIsCompareOptionsSelected(false);
    },
    getCapabilities() {
      if (this.currentSideNav.name === settings.name)
        return this.settingsCapabilities;

      return this.alertsCapabilities;
    },
    changeSeriesType(item) {
      this.selected = item;
      let params;
      let key = this.app.currentCapability;
      switch (key) {
        case CAPABILITY_BROWSER:
          params = {
            duration: this.getDurationTime,
            serviceId: this.selected,
          };
          this.selectBrowserService(params);
          break;
        case CAPABILITY_APM:
          params = {
            duration: this.getDurationTime,
            service: this.selected,
          };
          this.selectService(params);
          break;
        case CAPABILITY_MOBILE:
          params = {
            duration: this.getDurationTime,
            service: this.selected,
          };
          this.selectMobileService(params.service);
          break;
        default:
          break;
      }
    },
    selectCapabilityOption(item) {
      this.capabilitySelected = item;
      this.setDefaultParams();
      this.getAllServices();
      this.$emit('capabilityChanged', this.capabilitySelected.key);
    },
    setActiveCapabilityList() {
      const featureFlag =
        BuildConfig.VUE_APP_ACTIVE_CAPABILITIES ||
        process.env.VUE_APP_ACTIVE_CAPABILITIES ||
        '';
      const activeCapabilities = featureFlag.split(',');
      if (activeCapabilities.length > 0 && !activeCapabilities.includes('')) {
        this.settingsCapabilities = this.settingsCapabilities.filter(
          (capability) => {
            const capabilityKey = capability.key.toLowerCase();
            return activeCapabilities.includes(capabilityKey);
          },
        );
      }
    },
    setDefaultParams() {
      this.currentPage = 1;
      this.servicesData = [];
    },
  },
  created() {
    this.setActiveCapabilityList();
    this.capabilitySelected = this.getCapabilities()[0];
    this.serviceTypeHandler;
    this.getCurrentAlarmService;
    this.getAllServices();
  },
  watch: {
    currentService() {
      this.selected = this.currentService;
    },
    currentBrowserService() {
      this.selected = this.currentBrowserService;
    },
    currentMobileService() {
      this.selected = this.currentMobileService;
    },
    'currentSideNav.key': function () {
      if (this.showSelectV3) {
        this.setDefaultParams();
        this.getAllServices();
      }
    },
    '$route.name'() {
      if (this.app.currentSideNav.name === Mobile.name) {
        if (
          router.currentRoute.value &&
          router.currentRoute.value.name === 'mblDashboard'
        ) {
          const isAllExist = this.servicesData.some(
            (obj) => obj?.key === ALL_TYPE_APP.key,
          );
          !isAllExist && this.servicesData.unshift(ALL_TYPE_APP);
        } else {
          this.servicesData = this.servicesData.filter(
            (obj) => obj.key !== ALL_TYPE_APP.key,
          );
          const allTypeSelected = this.selectedService === ALL_TYPE_APP.label;
          const tempService = allTypeSelected
            ? this.servicesData[0]?.label
            : this.selectedService;
          let selectedItem = this.servicesData.find(
            (item) => item?.label === this.selectedService,
          );
          let service = {
            key: selectedItem?.key,
            label: tempService,
          };
          allTypeSelected && this.setCurrentMobileService(service);
        }
      }
    },
  },
  mounted() {
    this.checkAI();
  },
};
</script>

<style lang="scss" scoped>
.toolbar {
  margin-left: 0em;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  margin-left: 0em;
  margin-top: 0.8125em;
  background-color: transparent;
  color: $font-primary;
  width: 100%;
}

.item {
  margin-right: 1.875em;
}
.dropdown-ph > .select-box {
  width: 60rem !important;
}
.capability-dropdown {
  margin-right: 10px;
}
.services-loading-box {
  @include flex-center;
  height: 100%;
  width: 100%;
}
.select-apps-container {
  @include flex-center-justify(flex-start);
}
.heading {
  @include heading-text;
  margin-right: 0.5625em;
}
.service-opt-tooltip {
  overflow: hidden;
  white-space: nowrap;
}
.service-opt-tooltip-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
